import { EventsDefinitions } from "@graylog/server-api";
import { createTagsFilter } from "components/events/TagsFilter";
const SUGGESTION_LIMIT = 100;
const fetchSuggestions = (_streamId, query) => EventsDefinitions.suggestTags(query != null ? query : "", SUGGESTION_LIMIT).then(
  (response) => {
    var _a;
    return ((_a = response == null ? void 0 : response.tags) != null ? _a : []).sort().map((value) => ({ id: value, value }));
  }
);
const EventDefinitionTagsFilter = createTagsFilter({
  queryKeyPrefix: ["event-definitions", "tag-filter-suggestions"],
  fetchSuggestions,
  serverSidePrefix: true
});
export default EventDefinitionTagsFilter;
